import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import AccessibilityStatement from './components/AccessibilityStatement';
import NotFound from './components/NotFound';
import Footer from './components/Footer';
import './App.css';

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToAnchor = (anchor) => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: anchor } });
    } else {
      const el = document.getElementById(anchor);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="App d-flex flex-column">
      <div className="paper-grain" aria-hidden="true" />
      <Navigation navigateToAnchor={navigateToAnchor} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/accessibility" element={<AccessibilityStatement />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer navigateToAnchor={navigateToAnchor} />
    </div>
  );
}

export default App;
